module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, _vm._l((this.organizations), function(organization) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'organization_edit',
          params: {
            id: organization[0]
          }
        }
      }
    }, [_c('h3', {
      staticClass: "title--link"
    }, [_vm._v("\n        " + _vm._s(organization[0]) + " - " + _vm._s(organization[1]) + "\n      ")])])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31ad852e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/plans/PlanOrganizationList.vue
// module id = 1859
// module chunks = 0